import { User } from "@/api/requests";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const formattedPermissions = (userPermissions: { name: string }[]) => {
    if (!userPermissions) return {}
    const permissions: any = {
      profile: true,
      'change password': true,
    };
    for (const item of userPermissions) {
      permissions[item.name.toLowerCase()] = true;
    }
    return permissions
  };

const useUserPermission = ({
  userId,
}: {
  userId?: string
}) => {
  const queryClient = useQueryClient();
  const clearUserPermissions = () => {
    queryClient.removeQueries({ queryKey: ['userPermission'] });
  }

  const {
    data: userPermissions,
    isPending: isUserPermissionsLoading,
  } = useQuery({
    queryKey: ['userPermission', userId],
    queryFn: async () => {
      const { data } = await User.userPermissions(userId || '', undefined, 'permissions/list');
      return formattedPermissions(data.data)
    },
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 999_999_999_999,
    enabled: !!userId,
  });

  return {
    isUserPermissionsLoading,
    userPermissions,

    clearUserPermissions,
  }
};

export default useUserPermission;
